import { KeyValue } from '@/main/models/common';

export enum MappingTypeTypes {
  GET_MAPPING_TYPE = '@mappingType/GET_MAPPING_TYPE',
  SAVE_MAPPING_TYPE = '@mappingType/SAVE_MAPPING_TYPE',
  RESET_REDUCER_MAPPING_TYPE = '@mappingType/RESET_REDUCER_MAPPING_TYPE'
}

export interface MappingTypeState {
  readonly mappingType: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetMappingType {
  type: typeof MappingTypeTypes.GET_MAPPING_TYPE;
}

export interface SaveMappingType {
  type: typeof MappingTypeTypes.SAVE_MAPPING_TYPE;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerMappingType {
  type: typeof MappingTypeTypes.RESET_REDUCER_MAPPING_TYPE;
}

export type MappingTypeActionTypes =
  | GetMappingType
  | SaveMappingType
  | ResetReducerMappingType;

